import React, { useState } from "react";
import { Form, Input, Button, Typography, message, Card } from "antd";
import axios from "axios";
import { BASE_URL } from "../constants/Constants";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const SignUp = () => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const onFinish = async (values) => {
    const { name, email, password, phoneNo } = values;
    try {
      setLoading(true);
      await axios.post(
        `${BASE_URL}/users/addNewUserEmail`,
        null,
        {
          params: {
            emailId: email,
            password: password,
            name: name,
            phoneNo: phoneNo,
          },
        }
      );
      message.success("Account created successfully. Please sign in.");
      history.push("/sign-in");
    } catch (e) {
      message.error(
        e?.response?.data || "Failed to create account. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "80vh",
      }}
    >
      <Card title="Create your account" style={{ width: 420 }}>
        <Form layout="vertical" onFinish={onFinish} requiredMark={false}>
          <Form.Item
            label="Full Name"
            name="name"
            rules={[{ required: true, message: "Please enter your name" }]}
          >
            <Input placeholder="John Doe" />
          </Form.Item>
          <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: "Please enter your email" },
              { type: "email", message: "Enter a valid email" },
            ]}
          >
            <Input placeholder="you@example.com" />
          </Form.Item>
          <Form.Item
            label="Phone Number"
            name="phoneNo"
            rules={[{ required: true, message: "Please enter your phone" }]}
          >
            <Input placeholder="9999999999" />
          </Form.Item>
          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: "Please enter a password" }]}
          >
            <Input.Password placeholder="••••••••" />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              className="bg-blue-500"
              block
            >
              Sign Up
            </Button>
          </Form.Item>
          <Typography.Paragraph style={{ marginBottom: 0 }}>
            Already have an account? <a href="/sign-in">Sign in</a>
          </Typography.Paragraph>
        </Form>
      </Card>
    </div>
  );
};

export default SignUp;


